import { render, staticRenderFns } from "./ShowroomRiskCalculationWithTable.vue?vue&type=template&id=826ee61e"
import script from "./ShowroomRiskCalculationWithTable.vue?vue&type=script&lang=js"
export * from "./ShowroomRiskCalculationWithTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports